import {
  DonationNavBarContainer, 
  DonationNavBarRow, 
  DonationNavBarUserInfo,  
  DonationNavBarLogoRow, 
  DonationBenevPay,
  DonationNavBarLogo,
  DonationNavBackClick,
  DonationNavBarAccount
} from '../DonationNavBar/DonationNavBar.styles';
import { useAppSelector } from "store/hooks";
import { DefaultTextBold, DefaultTextLight, GreyTextBold, GreyTextLight } from "components/text/Text";
import { useNavigate } from "react-router-dom";
import Images from 'config/Images';
import UserAvatar from 'components/images/UserAvatar/UserAvatar';

function DonationNavBar(){
  const navigate = useNavigate();
  const user = useAppSelector(state => state.user);

  return (
    <DonationNavBarContainer>
      <DonationNavBarRow>
        <DonationNavBarLogoRow>
          <DonationNavBarLogo src={Images.benevvLogo}/>
          <DonationBenevPay>
            <DefaultTextBold>BENEV</DefaultTextBold>
          </DonationBenevPay>
          <DonationBenevPay>
            <DefaultTextLight>Pay</DefaultTextLight>
          </DonationBenevPay>
        </DonationNavBarLogoRow>
        <DonationNavBarUserInfo>
          <UserAvatar image={user.socialAvatarUrl}/>
          <DonationNavBarAccount>
            <GreyTextBold>{user.name}</GreyTextBold>
          </DonationNavBarAccount>
          <DonationNavBarAccount>
            <GreyTextLight>Donation Account</GreyTextLight>
          </DonationNavBarAccount>
        </DonationNavBarUserInfo>
      </DonationNavBarRow>
      <DonationNavBarRow>
        <DonationNavBackClick>
          <i className="fa-solid fa-chevron-left"/>
          <p onClick={() => navigate("/")}>
            &nbsp; Back
          </p>
        </DonationNavBackClick>
      </DonationNavBarRow>
    </DonationNavBarContainer>
  )
}

export default DonationNavBar;
